import { BaseEntity } from '../BaseEntity';
import { IEditForm,
    AfterFormPopulated, AfterDataLoad, SetState, AfterSubmit,
    AfterNew, SubmitExceptions, AfterInitialStateSet } from '../../interfaces/iedit-form';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CrudOperations } from '../../interfaces/crudOperations';
import { OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BaseDocument } from '../BaseDocument';
import { State } from '../models/State';
import { TranslateService } from '@ngx-translate/core';
import { DisplayException } from '../../models/display-exception';
import { QueryParams } from '../../types/query-parameters';
import { IPostbackRequest } from '../interfaces/ipostback-request';

export class EditForm<T extends BaseDocument> implements IEditForm, OnInit, AfterFormPopulated, AfterDataLoad,
    SetState, AfterSubmit<T>, AfterNew<T>, SubmitExceptions, AfterInitialStateSet {
    public form: FormGroup;
    private data: T;
    public state: string = null;
    public currentState: State = null;
    public isPopulated = false;
    public nextState: string = null;
    isEdit = false;
    public isLoading = false;
    private newParams: QueryParams = null;
    id: string;
    navigateLink: string;
    notificationsService: ToastrService;
    router: Router;
    dataService: CrudOperations<T>;
    activatedRoute: ActivatedRoute;
    location: Location;
    translate: TranslateService;
    public states?: State[];
    editForm: FormGroup;
    private submitParams: object;
    private cancelParams: object;
    constructor(
        ns: ToastrService,
        translate: TranslateService,
        r: Router,
        ds: CrudOperations<T>,
        ar: ActivatedRoute,
        l: Location,
        navigateTo?: string,
        states?: State[]
    ) {
        this.notificationsService = ns;
        this.router = r;
        this.dataService = ds;
        this.activatedRoute = ar;
        this.location = l;
        this.navigateLink = navigateTo;
        this.states = states;
        this.translate = translate;
    }
    onAfterInitialStateSet(state: string): void {
    }
    ngOnInit() {
        this.id = this.activatedRoute.snapshot.params['id'];
        if (this.id) {
            this.isEdit = true;
            this.onLoad();
        } else {
            this.onNew();
        }
        this.state = this.activatedRoute.snapshot.queryParamMap.get('state');
    }
    get currentData(): T {
        return this.data;
    }
    onAfterDataLoad() {
        if (this.state && this.states) {
            const activeState = this.states.find( f => f.code === this.state);
            if (activeState) {
                this.data.stateId = activeState.id;
            }
        } else if (!this.data.hasOwnProperty('stateId')) {
            // no state object
        } else if (!(this.data.stateId) && this.states && this.states.length > 0) {
            const activeState = this.states[0];
            this.data.stateId = activeState.id;
            this.state = activeState.code;
            this.onAfterInitialStateSet(this.state);
        }
    }
    onAfterFormPopulated() {
    }
    patchData(data: Object) {
        if (data) {
            this.data = Object.assign(this.data, data);
        }
    }
    setNewParameters(params: QueryParams) {
        this.newParams = params;
    }
    onNew() {
        this.data = null;
        this.dataService.New(this.newParams).subscribe((resp) => {
            if (resp) {                
                this.data = resp.payload;                
                this.data = this.onAterNew(this.data);                
                this.onAfterDataLoad();
                const data: T = Object.assign({}, this.data);
                this.form.patchValue(data);
                this.isPopulated = true;
                this.onAfterFormPopulated();
            }
        });
    }
    onAterNew(model: T): T {
        return model;
    }

    onLoad() {
        this.isLoading = true;
        this.dataService.Get(this.id).subscribe((result) => {
            this.data = result.payload;
            if (this.data) {
                if (this.states) {
                    const currentState  = this.states.find(f => f.id === this.data.stateId);
                    if (currentState) {
                        this.state = currentState.code;
                    }
                }
            }
            this.onAfterDataLoad();
            this.form.patchValue(this.data);
            this.isPopulated = true;
            this.isLoading = false;
            this.onAfterFormPopulated();
        });
    }

    onSubmitExceptions(response: DisplayException): void {
        if (response) {
            this.translate.get(response.Type).subscribe(msg => {
                this.notificationsService.error(response.Message, msg);
            });
        }
    }
    onPostback(code: string, attributeId: string, operationCode: string = null) {
        const formValue = this.form.value;
        if(!operationCode) {
            operationCode = code;
        }
        const data: IPostbackRequest<T> = {
            code: code,
            changedAttributeId: attributeId,
            payload: formValue
        };
        return this.dataService.Postback(operationCode, data);
    }
    onSubmit() {
        this.data = this.form.value;
        const data: T = Object.assign({}, this.data);
        this.isLoading = true;
        if (this.isEdit) {
            this.dataService.Update(data).subscribe(() => {
                this.translate.get('crud.updated').subscribe(updated => {
                    const documentId = data.name?data.name:data.code;
                    this.notificationsService.success(documentId, updated);
                    this.onNavigate('edit');
                });
              }, (error) => {
                this.onSubmitExceptions(error);
              }, () => {
                this.isLoading = false;
              });
        } else {
            this.dataService.Create(data).subscribe((resp) => {
                this.translate.get('crud.created').subscribe(created => {
                    const documentId = resp.payload.name?resp.payload.name:resp.payload.code;
                    this.notificationsService.success(documentId, created);
                    this.onAterSubmit(resp.payload);
                });
              }, error => {
                this.onSubmitExceptions(error);
              }, () => {
                this.isLoading = false;
              });
        }
    }
    onAterSubmit(model: T) {
        this.onNavigate('submit');
    }
    onCancel() {
        this.onNavigate('cancel');
    }
    private getQueryParams(params: object) {
        let ret = null;
        if (params) {
            ret = {};
            Object.keys(params).forEach(key => {
                ret[key] = params[key];
            });
        }
        return ret;
    }
    onNavigate(action: string = null) {
        if (this.navigateLink) {
            let params = null;
            if (action === 'submit' || action === 'edit') {
                params = this.getQueryParams(this.submitParams);
            } else if (action === 'cancel') {
                params = this.getQueryParams(this.cancelParams);
            }
            if (params) {
                this.router.navigate([this.navigateLink], { queryParams: params});
            } else {
                this.router.navigate([this.navigateLink]);
            }
        } else {
            window.history.back();
        }
    }
    onSelectState(state: State) {
        this.form.patchValue({stateId: state.id});
      }
    getStateCode(id: string) {
    const state: State = this.states.find(f => f.id === id);
    return state ? state.code : null;
    }
    public setState(state: string) {
        if (this.states) {
            this.currentState = this.states.find(f => f.code === state);
            if (this.currentState) {
                this.state = this.currentState.code;
                if (this.form.contains('stateId')) {
                    this.form.controls['stateId'].setValue(this.currentState.id);
                }
            }
        }
     }
     public changeState(state: string) {
         const currentRoute: string = this.router.url;
         this.router.navigate([currentRoute], { queryParams: {state: state}});
    }
    public reload() {
        const currentRoute = this.router.url;
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
        this.router.navigate([currentRoute]));
    }
    public setNavigationParameters(submitParams: object, cancelParams: object = null) {
        this.submitParams = submitParams;
        if (!cancelParams) {
            this.cancelParams = cancelParams;
        }
    }
}
